var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bnb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0457317073 0.487804878 499.511433 0.487804878 499.511433 499.999238 0.0457317073 499.999238"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bnb",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    id: "BNB-(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.849848,210.282012 L249.756098,113.378811 L346.911585,210.532012 L403.355945,154.087652 L249.756098,0.487804878 L96.4054878,153.837652 L152.849848,210.282012 L152.849848,210.282012 Z M0,250.243902 L56.4443598,193.799543 L112.891006,250.243902 L56.4443598,306.6875 L0,250.243902 Z M152.849848,290.20503 L249.756098,387.11128 L346.911585,289.95503 L403.355945,346.39939 L249.756098,499.999238 L96.4054878,346.64939 L152.849848,290.20503 L152.849848,290.20503 Z M386.623476,250.243902 L443.067835,193.799543 L499.511433,250.243902 L443.067835,306.6875 L386.623476,250.243902 Z",
    id: "Fill-1",
    fill: "#F3BA2F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#F3BA2F",
    points: "307 250.124848 249.875152 193 193 249.875152 250.124848 307 307 250.124848"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.58db0dd53fb2e0b7d2eb86dc2d9b9b02.svg";
export { ForwardRef as ReactComponent };